import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Tooltip from '@atlaskit/tooltip';
import { CellWrapper } from '@atlassian/jira-directory-base-v3/src/ui/table-cells/styled.tsx';
import type { LastIssueUpdateCell$key } from '@atlassian/jira-relay/src/__generated__/LastIssueUpdateCell.graphql';

type Props = {
	project: LastIssueUpdateCell$key;
};

export const LastIssueUpdateCell = ({ project }: Props): React.JSX.Element | null => {
	const { lastUpdatedToolTipDate, lastUpdatedDisplayDate } = useFragment(
		graphql`
			fragment LastIssueUpdateCell on JiraProject {
				lastUpdatedToolTipDate: lastUpdatedFormatted(format: COMPLETE_DATETIME_FORMAT)
				lastUpdatedDisplayDate: lastUpdatedFormatted(format: RELATIVE)
			}
		`,
		project,
	);

	if (!lastUpdatedDisplayDate) {
		return null;
	}

	return (
		<CellWrapper>
			<Tooltip content={lastUpdatedToolTipDate} position="top">
				<span>{lastUpdatedDisplayDate}</span>
			</Tooltip>
		</CellWrapper>
	);
};
